import { Button } from 'flowbite-react'
import React from 'react'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
interface DeleteBeneficiaryProps{
    close:()=>void
    id:number
}
const DeleteBeneficiary = ({close, id}:DeleteBeneficiaryProps) => {
    console.log(id)
    const deleteBeneficiary =async()=>{
        try {
            const response = await client.delete(`/subsidiary/beneficiary/delete/${id}`);
            const message = response?.data?.message;
            showToast(message,"success")
            close()
            // onSuccess()
    
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);            
                showToast(message, "error");
            }
        }
        finally{
            close()
        }
    }
  return (
    <div>
      <p className='text-sm'>Are you sure you want to delete this beneficiary?</p>
      <div className='w-full flex gap-3 mt-3'>
        <Button className='w-full bg-white text-black' outline onClick={()=>close()}>No</Button>
        <Button className='w-full bg-custom-button-green' onClick={()=>deleteBeneficiary()}>Yes</Button>
      </div>
    </div>
  )
}

export default DeleteBeneficiary
